import React from 'react';
import SettingsSlider from './SettingsSlider';

export interface SettingsOpacitySliderProps {
  label?: string;
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}

const SettingsOpacitySlider: React.FC<SettingsOpacitySliderProps> = ({
  label = 'Opacity',
  value,
  onChange,
  min = 0.3,
  max = 1,
  step = 0.05,
  disabled,
}) => (
  <SettingsSlider
    label={label}
    value={Math.round(value * 100)}
    onChange={(v) => onChange(v / 100)}
    min={Math.round(min * 100)}
    max={Math.round(max * 100)}
    step={Math.round(step * 100)}
    unit="%"
    disabled={disabled}
  />
);

export default SettingsOpacitySlider;
